// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xbfc","colBig":"styles_colBig__2TC80","colSmall":"styles_colSmall__32Qf_"};